import Pypestream from 'pages/pypestream';
import SupportV2CategoriesPage from 'pages/support-v2/support-v2-categories-page';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function SupportPage() {
  const enablePypestream = useFlag(LaunchDarklyFlag.ENABLE_PYPESTREAM);
  return enablePypestream ? <Pypestream /> : <SupportV2CategoriesPage />;
}
